import React from 'react'
import Navbar from '../../components/navbar'
import bg1 from '../../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'

import {FiUser, FiMail,FiBook, FiMessageCircle} from '../../assets/icons/vander'
import Footer from '../../components/footer'

export default function HelpSupport() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Support</h4>
                          <p className="text-muted mb-0">Mack customer happy and scale customer service without <br/> increasign unit costs.</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Help Center</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Support</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-7 col-12">
                  <div className="rounded p-4 shadow">
                      <div className="row">
                          <div className="col-12">
                              <form>
                                  <div className="row">
                                      <div className="col-md-6">
                                          <div className="mb-3">
                                              <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                              <div className="form-icon position-relative">
                                                  <FiUser className="fea icon-sm icons"/>
                                                  <input name="name" id="name" type="text" className="form-control ps-5" placeholder="First Name :"/>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="col-md-6">
                                          <div className="mb-3">
                                              <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                              <div className="form-icon position-relative">
                                                  <FiMail className="fea icon-sm icons"/>
                                              <input name="email" id="email" type="email" className="form-control ps-5" placeholder="Your email :"/>
                                              </div>
                                          </div> 
                                      </div>
                                      <div className="col-md-12">
                                          <div className="mb-3">
                                              <label className="form-label">Subject</label>
                                              <div className="form-icon position-relative">
                                                  <FiBook className="fea icon-sm icons"/>
                                                  <input name="subject" id="subject" className="form-control ps-5" placeholder="Your subject :"/>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="col-md-12">
                                          <div className="mb-3">
                                              <label className="form-label">Comments</label>
                                              <div className="form-icon position-relative">
                                                  <FiMessageCircle className="fea icon-sm icons"/>
                                                  <textarea name="comments" id="comments" rows="4" className="form-control ps-5" placeholder="Your Message :"></textarea>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row">
                                      <div className="col-sm-12">
                                          <input type="submit" id="submit" name="send" className="btn btn-primary" value="Send Request"/>
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
